export default __webpack_public_path__ + "images/624dcc2ceef2a8fac38c7b064f39702c-Daybreaker_4K_1920x544.jpg";